// @flow

import glamorous from 'glamorous';
import { margin } from 'polished';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import VS from '../../components/icons/VS';

type Props = {
  darkMode: boolean,
  matchUps: Array<Array<Object>>,
  renderPlayer: (player: Object, index: number, isYou: boolean) => React.Node,
  useVsBackground?: boolean,
};

const MatchRow = glamorous.div(
  {
    position: 'relative',
    display: 'flex',
    // alignItems: 'center',
    justifyContent: 'center',
  },
  ({ ruledOut, theme }) => ({
    color: theme.color.basis2,
    padding: '0.2em 0',
    opacity: ruledOut ? 0.5 : 1,
    textDecoration: ruledOut ? 'line-through' : undefined,
  }),
);

const VsWrapper = glamorous.div(
  ({ theme }) => ({
    position: 'relative',
    padding: theme.spacing.xsmall,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: theme.color.white,
    color: theme.color.black,
    fontSize: theme.fontSize.default,
  }),
  ({ theme }) => ({
    [theme.mediaQuery.desktopAndUp]: {
      fontSize: theme.fontSize.large,
    },
  }),
  ({ darkMode, theme, whiteBackground }) =>
    (darkMode
      ? {
        [theme.mediaQuery.desktopAndUp]: {
          background: whiteBackground ? 'white' : 'transparent',
          color: whiteBackground ? theme.color.black : theme.color.white,
        },
      }
      : {
        [theme.mediaQuery.desktopAndUp]: {
          background: whiteBackground ? 'white' : 'transparent',
          color: whiteBackground ? theme.color.black : theme.color.black,
        },
      }),
);

class MatchUps extends Component<Props> {
  props: Props;

  render() {
    const { darkMode, matchUps, renderPlayer, useVsBackground } = this.props;
    return (
      <div>
        {matchUps.map(([player1, player2], i) => (
          <MatchRow key={player1.id} ruledOut={player1.ruledOut}>
            {renderPlayer(player1, player2, i, true)}
            <VsWrapper darkMode={darkMode} whiteBackground={useVsBackground}>
              <VS />
            </VsWrapper>
            {renderPlayer(player2, player1, i, false)}
          </MatchRow>
        ))}
      </div>
    );
  }
}

MatchUps.defaultProps = {
  useVsBackground: false,
};

function mapStateToProps(state) {
  return {
    darkMode: state.settings.darkMode,
  };
}

export default connect(mapStateToProps)(MatchUps);
